module.exports = "/assets/router-signal.jpg";